import { networkCall } from "../../../../../../util/network-call/network-call";

export const AdminDeletedCompanyListLoader = async () => {

    const getCompaniesResponse = await networkCall('/companies?deleted=true');

    return { getCompaniesResponse };

};